const mergeFocusHandlers = ({ handleFocus, handleBlur, onBlur }) => {
    const mergedHandleBlur = (e) => {
        handleBlur();
        onBlur(e);
    };
    return {
        onFocus: handleFocus,
        onBlur: mergedHandleBlur
    };
};
export default mergeFocusHandlers;
//# sourceMappingURL=index.js.map